
let visibleCount = 10;
const incrementAmount = 10;

var doWorkout = {

    initFilters = () => {
        const filterBtn = document.getElementById('workout-filter-btn');
        const modal = document.getElementById('workout-filter-modal');
        const overlay = document.getElementById('workout-overlay');
        const closeModalBtn = document.getElementById('workout-close-modal-btn');
        const acceptBtn = document.getElementById('workout-filter-accept-btn');
        const resetBtn = document.getElementById('workout-filter-reset-btn');
        const listItems = document.querySelectorAll('.filter-checkbox');
        const items = document.querySelectorAll('.workout-item');
        const filterCountSpan = document.getElementById('filter-count');
        const checkboxes = document.querySelectorAll('.filter-checkbox');
        const showAllBtn = document.getElementById('workout-filter-list-show-all-btn');

        showAllBtn?.addEventListener("click", () => {
            visibleCount += incrementAmount;
            applyFilters();
        });

        const openModal = () => {
            utils.common.showElement(modal);
            utils.common.showElement(overlay);
            utils.modal.trapFocus(modal);
            checkmarkBoxes();
            updateFilter();
            filterBtn.setAttribute('aria-expanded', "true");
            overlay.setAttribute("aria-hidden", "false");
            closeModalBtn.setAttribute("aria-expanded", "true");
        };

        const closeModal = () => {
            utils.common.hideElement(modal);
            utils.common.hideElement(overlay);
            filterBtn.setAttribute('aria-expanded', "false");
            overlay.setAttribute("aria-hidden", "true");
            closeModalBtn.setAttribute("aria-expanded", "false");
            utils.modal.removeTrapFocus();
        };

        filterBtn?.addEventListener("click", openModal);
        closeModalBtn?.addEventListener("click", closeModal);
        overlay?.addEventListener("click", closeModal);

        acceptBtn?.addEventListener("click", () => {
            updateURL();
            closeModal();
        });

        resetBtn?.addEventListener("click", () => {
            resetAllFilters();
        });

        // Updates checkboxes -- toLowerCase to always be sure that everything stays the same
        const checkmarkBoxes = () => {
            const urlParams = utils.url.checkUrlParams(Object.keys(checkedFilters), true)

            checkboxes.forEach(checkbox => {
                const paramName = checkbox.dataset.id;
                const checkboxValue = checkbox.dataset.value;
                checkbox.addEventListener('change', updateFilterOptions);
                if (urlParams.has(paramName) && urlParams.get(paramName).split(',').includes(checkboxValue)) {
                    checkbox.checked = true;
                    if (!checkedFilters[paramName].includes(checkboxValue)) {
                        checkedFilters[paramName].push(checkboxValue)
                    }
                }
            });
        };

        // Updates URL && counter -- toLowerCase() --
        const updateURL = () => {

            const urlParams = utils.url.checkUrlParams(Object.keys(checkedFilters), true);
            let appliedFiltersCount = 0;

            checkboxes.forEach(checkbox => {
                const paramName = checkbox.dataset.id;
                const paramValue = checkbox.dataset.value;

                if (checkbox.checked) {
                    appliedFiltersCount++;
                }
                utils.url.updateURLParameter(urlParams, paramName, paramValue, checkbox.checked);
            });


            const noFiltersApplied =
                checkedFilters['city'].length === 0 &&
                checkedFilters['facility'].length === 0 &&
                checkedFilters['workouttype'].length === 0 &&
                checkedFilters['targetgroup'].length === 0;

            let newUrl;
            if (noFiltersApplied) {
                newUrl = window.location.pathname;
            } else {
                newUrl = utils.url.decodedUrl(urlParams);
            }
            window.history.replaceState({}, '', newUrl);
            applyFilters();
            if (filterCountSpan) utils.common.updateFilterButton(appliedFiltersCount, filterCountSpan);

        };

        const applyFilters = () => {
            const urlParams = utils.url.checkUrlParams(Object.keys(checkedFilters), true);

            const selectedValues = {};

            urlParams.forEach((value, key) => {
                const matchingCheckboxes = Array.from(checkboxes).filter(checkbox => {
                    return value.includes(checkbox.getAttribute('data-value') || '');
                });
                selectedValues[key] = matchingCheckboxes.map(checkbox => checkbox.dataset.value || '');
            });

            const matchedItems = [];

            items.forEach(item => {
                const targetGroups = item.dataset.targetgroups || "";
                const cities = item.dataset.cities || "";
                const facilities = item.dataset.facilities || "";
                const workouttype = item.dataset.workouttype || "";

                let showItem = true;

                for (let key in selectedValues) {
                    const checkboxValues = selectedValues[key];

                    if (checkboxValues.length > 0) {
                        if (
                            (key === 'targetgroup' && !checkboxValues.some(val => targetGroups.includes(val))) ||
                            (key === 'city' && !checkboxValues.some(val => cities.includes(val))) ||
                            (key === 'facility' && !checkboxValues.some(val => facilities.includes(val))) ||
                            (key === 'workouttype' && !checkboxValues.some(val => workouttype.includes(val)))
                        ) {
                            showItem = false;
                            break;
                        }
                    }
                }

                if (showItem) {
                    matchedItems.push(item);
                }

                // hide all by default
                item.style.display = "none";
            });

            matchedItems.slice(0, visibleCount).forEach(item => {
                item.style.display = "flex";
            });

            if (showAllBtn) {
                if (visibleCount < matchedItems.length) {
                    showAllBtn.style.display = "flex";
                } else {
                    showAllBtn.style.display = "none";
                }
            }

            // Update filter count
            let appliedFiltersCount = 0;
            urlParams.forEach((value, key) => {
                if (key in checkedFilters) {
                    appliedFiltersCount += value.split(',').length;
                }
            });

            if (filterCountSpan) {
                utils.common.updateFilterButton(appliedFiltersCount, filterCountSpan);
            }
        };


        /***                              ***/
        /*** FILTER STATE CONTROLLERS    ***/
        /***                             ***/
        let checkedFilters = {
            city: [],
            facility: [],
            workouttype: [],
            targetgroup: []
        };

        const updateVisibility = (filteredList) => {
            listItems.forEach(item => {

                const itemValue = item.dataset.value;

                const isCityMatched = filteredList.some(filteredItem => filteredItem['data-cities'].includes(itemValue));
                const isFacilityMatched = filteredList.some(filteredItem => filteredItem['data-facilities'].includes(itemValue));
                const isWorkoutTypeMatched = filteredList.some(filteredItem => filteredItem['data-workouttype'].includes(itemValue));
                const isTargetGroupMatched = filteredList.some(filteredItem => filteredItem['data-targetgroups'].includes(itemValue));


                const isVisible = isCityMatched || isFacilityMatched || isWorkoutTypeMatched || isTargetGroupMatched;

                if (isVisible) {
                    item.disabled = false;
                } else {
                    item.disabled = true;
                }

            });
        };


        const updateFilterOptions = (event) => {
            const value = event.target.getAttribute('data-value');
            const type = event.target.getAttribute('data-id');
            const isChecked = event.target.checked;

            if (isChecked) {
                if (!checkedFilters[type].includes(value)) {
                    checkedFilters[type].push(value);
                }
            } else {
                const index = checkedFilters[type].indexOf(value);
                if (index > -1) {
                    checkedFilters[type].splice(index, 1);
                }
            }

            updateFilter();

        };


        const updateFilter = () => {
            // Reset filters if all checked filters are empty
            if (
                checkedFilters['city'].length === 0 &&
                checkedFilters['facility'].length === 0 &&
                checkedFilters['workouttype'].length === 0 &&
                checkedFilters['targetgroup'].length === 0
            ) {
                return resetAllFilters();
            }

            const filteredList = Array.from(items).reduce((acc, item) => {
                const dataAttributes = {};
                Array.from(item.attributes).forEach(attr => {
                    if (
                        attr.name.startsWith('data-')
                    ) {
                        dataAttributes[attr.name] = attr.value;
                    }
                });

                const cityAttributes = dataAttributes['data-cities'];
                const cityFilter = checkedFilters['city'];

                const facilityAttributes = dataAttributes['data-facilities']
                const facilityFilter = checkedFilters['facility']

                const workoutTypeAttributes = dataAttributes['data-workouttype'];
                const workoutTypeFilter = checkedFilters['workouttype'];

                const targetGroupsAttributes = dataAttributes['data-targetgroups']
                const targetGroupFilter = checkedFilters['targetgroup']


                // Check if any targetgroups in targetGroupFilter is present in targetGroupAttributes
                const isTargetGroupMatched = targetGroupFilter.some(targetgroup => targetGroupsAttributes.includes(targetgroup));
                // Check if any workout type in workoutTypeFilter is present in workoutTypeAttributes
                const isWorkoutTypeMatched = checkedFilters['targetgroup'].length > 0 ? false : workoutTypeFilter.some(workouttype => workoutTypeAttributes.includes(workouttype));
                // Check if any facility in facilityFilter is present in facilityAttributes
                const isFacilityMatched = checkedFilters['targetgroup'].length > 0 || checkedFilters['workouttype'].length > 0 ? false : facilityFilter.some(facility => facilityAttributes.includes(facility));
                // Check if any city in cityFilter is present in cityAttributes
                const isCityMatched = checkedFilters['targetgroup'].length > 0 || checkedFilters['workouttype'].length > 0 || checkedFilters['facility'].length > 0 ? false : cityFilter.some(city => cityAttributes.includes(city));

                if (isCityMatched || isFacilityMatched || isWorkoutTypeMatched || isTargetGroupMatched) {
                    acc.push(dataAttributes);
                }

                return acc;
            }, []);


            updateVisibility(filteredList)

        };


        /***                    ***/
        /***** FILTER HELPERS *****/
        /***                   ***/

        // Function to reset all filters and show all options
        const resetAllFilters = () => {
            // Reset checkedFilters to be empty
            checkedFilters = {
                city: [],
                facility: [],
                workouttype: [],
                targetgroup: []
            };

            listItems.forEach(element => {
                element.disabled = false;
                element.checked = false;
            });
        };

        // Call applyFilters initially
        applyFilters();

    }

}

document.addEventListener('DOMContentLoaded', () => {
    doWorkout.initFilters();
});
